import { gql } from '@apollo/client';

export const SEND_CONFIRM_PHONE_NUMBER = gql`
    mutation SendConfirmPhoneNumber($id: ID!) {
        sendConfirmPhoneNumber(id: $id) {
            id
        }
    }
`;
